import React from 'react';

const CreditBalanceCard = ({ wallet, onBuy, onViewTransactions }) => {
  const balance = wallet?.balance || 0;
  const purchased = wallet?.totalPurchased || 0;
  const used = wallet?.totalUsed || 0;

  return (
    <>
      <div className="cr-balance-main">
        <div className="cr-balance-label">Available Credits</div>
        <div className="cr-balance-value">{balance.toLocaleString()}</div>
        <div className="cr-balance-sub">≈ ${balance.toLocaleString()} USD equivalent</div>
        <div className="cr-balance-actions">
          <button className="cr-btn cr-btn-primary" onClick={onBuy}>
            <i className="fas fa-plus"></i> Buy Credits
          </button>
          <button className="cr-btn cr-btn-secondary" onClick={onViewTransactions}>
            <i className="fas fa-history"></i> View Transactions
          </button>
        </div>
      </div>
      <div className="cr-stat-card">
        <span className="label">Total Purchased</span>
        <span className="value green">{purchased.toLocaleString()}</span>
        <span style={{ fontSize: '12px', color: '#888' }}>credits</span>
      </div>
      <div className="cr-stat-card">
        <span className="label">Total Used</span>
        <span className="value">{used.toLocaleString()}</span>
        <span style={{ fontSize: '12px', color: '#888' }}>credits</span>
      </div>
    </>
  );
};

export default CreditBalanceCard;